module.exports = __webpack_public_path__ + "static/img/brand-3.f84573f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-3.svg
// module id = VOaS
// module chunks = 0